import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAxiosClient from "./useAxiosClient";

import { TRootState } from "../store";
import { TPaymentHistory, TTradeDocument } from "../types/trades/trades";
import { updateTradeNotifications } from "../reducers/trade_details_Slice";

const usePayNotifications = ({ status }: { status?: boolean }) => {
  const { handleGetCall } = useAxiosClient();
  const { adminId, tententType, notifications } = useSelector(
    (state: TRootState) => ({
      adminId: state.auth.adminId,
      tententType: state.auth.userInfo?.type,
      notifications: state.tradeDetails.notifications,
    })
  );
  // const [notifications, setNotifications] = useState<TPaymentHistory[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    const selectedPath = localStorage.getItem('selectedPath');

    if (selectedPath !== 'price-prediction') {
      getNotifications();
    }
  }, [status]);

  // useEffect(() => {
  const getNotifications = () => {
    handleGetCall<TPaymentHistory[]>(
      `/admin/trade-platform/trades/adminId/${adminId}?tenant=${tententType}`
    ).then(({ data }) => {
      if (data) {
        let d = data.map((d) => {
          let images: TTradeDocument[] = [];
          d?.imgs?.forEach((img) => {
            images.push({
              ...img,
              docType: img.url?.toLowerCase().includes(".pdf")
                ? "pdf"
                : "image",
              status: 1
            });
          });
          return {
            ...d,
            id: d.pmtId,
            pmtType: d.paymentType,
            images: images,

          };
        });
        dispatch(updateTradeNotifications(d));
        setIsLoading(false);
      } else {
        dispatch(updateTradeNotifications([]));
        setIsLoading(false);
      }
    });
  };

  return { notifications, isLoading, setIsLoading, getNotifications };
};
export default usePayNotifications;
